var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorrect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2789 8.28082C16.4114 8.13865 16.4835 7.9506 16.48 7.7563C16.4766 7.562 16.3979 7.37662 16.2605 7.2392C16.1231 7.10179 15.9377 7.02308 15.7434 7.01965C15.5491 7.01622 15.361 7.08834 15.2189 7.22082L9.24887 13.1908L6.77887 10.7208C6.6367 10.5883 6.44865 10.5162 6.25435 10.5196C6.06005 10.5231 5.87466 10.6018 5.73725 10.7392C5.59983 10.8766 5.52112 11.062 5.51769 11.2563C5.51427 11.4506 5.58639 11.6386 5.71887 11.7808L8.71887 14.7808C8.8595 14.9213 9.05012 15.0002 9.24887 15.0002C9.44762 15.0002 9.63824 14.9213 9.77887 14.7808L16.2789 8.28082Z",
    fill: "#8F96A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C4.925 0 0 4.925 0 11C0 17.075 4.925 22 11 22C17.075 22 22 17.075 22 11C22 4.925 17.075 0 11 0ZM1.5 11C1.5 8.48044 2.50089 6.06408 4.28249 4.28249C6.06408 2.50089 8.48044 1.5 11 1.5C13.5196 1.5 15.9359 2.50089 17.7175 4.28249C19.4991 6.06408 20.5 8.48044 20.5 11C20.5 13.5196 19.4991 15.9359 17.7175 17.7175C15.9359 19.4991 13.5196 20.5 11 20.5C8.48044 20.5 6.06408 19.4991 4.28249 17.7175C2.50089 15.9359 1.5 13.5196 1.5 11Z",
    fill: "#8F96A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/correct.438c156afc2065ea490760fb9c80ce66.svg";
export { ForwardRef as ReactComponent };